import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { DeclarativeModal } from 'seagull';
import { useStore, useStoreActions, useStoreStatic } from '~/contexts';
import { useAgreements } from '~/hooks/reactQuery/queries/useAgreements';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useLegalTerms } from '~/hooks/reactQuery/queries/useLegalTerms';
import { useProposals } from '~/hooks/reactQuery/queries/useProposals';
import { useOnMount } from '~/hooks/useOnMount';
import { agreementStudioAgreementsArgs } from '~/pages/AgreementsDashboard/agreementsDashboardFilters';
import { selectors } from '~/store/state-selectors';
import { makeSentryIgnoredError } from '../../ErrorBoundaryPage';
import { AgreementStudioTemplateMode } from './AgreementStudioTemplateMode';
export default function AgreementStudioTemplates(props) {
    const { fetchFinancialCentsUsers, fetchKarbonUsers } = useStoreActions();
    useAgreements(_object_spread_props(_object_spread({}, agreementStudioAgreementsArgs), {
        refreshOnHookMount: true,
        withLoader: true
    }));
    useProposals({
        refreshOnHookMount: true,
        withLoader: true
    });
    useContacts({
        refreshOnMount: true,
        withLoader: true
    });
    useLegalTerms({
        refreshOnHookMount: true
    });
    const { getState } = useStoreStatic();
    const worksAt = useStore(selectors.user.business);
    const userEmail = useStore(selectors.user.email);
    useOnMount(()=>{
        if (selectors.integration.showFinancialCentsIntegration(getState())) {
            fetchFinancialCentsUsers();
        }
        if (selectors.integration.showKarbonIntegration(getState())) {
            fetchKarbonUsers();
        }
    });
    if (!worksAt || !userEmail) throw makeSentryIgnoredError('noBusiness');
    return /*#__PURE__*/ _jsx(DeclarativeModal, {
        biName: "agreement_studio_templates",
        isOpen: true,
        treatAsPage: true,
        content: ()=>/*#__PURE__*/ _jsx(AgreementStudioTemplateMode, _object_spread_props(_object_spread({}, props), {
                template: props.template || null,
                worksAt: worksAt,
                userEmail: userEmail
            }))
    });
}
